import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const TIPO_PIEZAS_API = {
    get: async () => {
        return await API.get('/tipo_piezas').then(res => res.data);
    },
    new: async (tipoPieza) => {
        return API.post('/tipo_piezas', tipoPieza).then(res => res.data);
    },
    importMeasurements: async (excel) => {
        return API.post('tipo_piezas/import', excel, headers).then(res => res.data);
    },
    update: async (tipoPieza) => {
        return API.put('/tipo_piezas/' + tipoPieza.id, tipoPieza).then(res => res.data);
    }
}